import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import fileDownload from "js-file-download";
import React, { useContext, useState, useEffect } from "react";
import { useTheme, withStyles } from "@material-ui/core/styles";
import { DeviceHub, GetApp, Person } from "@material-ui/icons";
import { VehicleDataWidgetActionButton } from "../../VehicleDataWidget/subcomponents";
import { vehicleHistoryStyles } from "./sharedStyles";
import { ModalContext } from "../../Modals/DiagnosticModal/DiagnosticModal";
import { RiderContext } from "../../../../context";
import { StringUtils } from "../../../../util";
import { PermissionedDisplay } from "../../../../components/Layout";
import Permissions from "../../../../permissions";
import useMediaQuery from "../../../../hooks/useMediaQuery";
import RouteIcon from "../../../../assets/fleet-deployment/routeIcon.svg";

export const downloadDiagnostics = async (eventList) => {
  const eventPromises = eventList.map((event) => event.toRawLog());
  const diagnostics = (await Promise.all(eventPromises)).map((event) => event[0]);
  fileDownload(JSON.stringify(diagnostics), "events.json");
};

export const TimelineStatusSummary = ({
  classes,
  events,
  timelineStatus,
  onShowPathChange,
}) => {
  const { fetchReservationByTrip } = useContext(RiderContext);
  const history = useHistory();
  const [reservation, setReservation] = useState(null);
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchReservation = async (tripId) => {
      try {
        const res = await fetchReservationByTrip(tripId);
        setReservation(res);
      } catch (e) {
        console.warn(e);
      }
    };

    if (!reservation) {
      const tripEvent = events.find((e) => e.is_trip);
      if (tripEvent) fetchReservation(tripEvent.id);
    }
  }, []);

  const redirectToReservationDetailPage = async () => {
    const riderId = StringUtils.uuidFromUrl(reservation.rider);
    history.push(`/riders/${riderId}/reservations/${reservation.id}`);
  };

  const filteredEvents = events.filter(
    (event) => !(event.type && ["tripStart", "timelineGraphic"].includes(event.type)),
  );

  return (
    <ModalContext.Consumer>
      {({ setDiagnostics }) => (
        <div className={classes.summaryRoot}>
          <div className={classes.actionsWrapper}>
            {reservation?.rider && (
              <PermissionedDisplay permission={Permissions.readRidersAdmin}>
                <VehicleDataWidgetActionButton
                  action="RiderDetails"
                  handleClick={redirectToReservationDetailPage}
                  isCompact
                  icon={
                    <Person
                      style={{
                        height: 20,
                        width: 20,
                        color: theme.palette.text.blue,
                      }}
                    />
                  }
                />
              </PermissionedDisplay>
            )}
            <VehicleDataWidgetActionButton
              action="Diagnostics"
              handleClick={setDiagnostics(filteredEvents)}
              isCompact
              icon={
                <DeviceHub
                  style={{
                    height: 20,
                    width: 20,
                    color: theme.palette.text.blue,
                  }}
                />
              }
            />
            {timelineStatus === "reserved" && !isMobile && (
              <PermissionedDisplay permission={Permissions.readTripEvents}>
                <VehicleDataWidgetActionButton
                  action="ShowPath"
                  handleClick={onShowPathChange}
                  isCompact
                  icon={<img src={RouteIcon} alt="Show Route" />}
                />
              </PermissionedDisplay>
            )}
            <VehicleDataWidgetActionButton
              handleClick={() => downloadDiagnostics(filteredEvents)}
              isCompact
              icon={
                <GetApp
                  style={{
                    height: 25,
                    width: 25,
                    color: theme.palette.text.blue,
                  }}
                />
              }
            />
          </div>
        </div>
      )}
    </ModalContext.Consumer>
  );
};

TimelineStatusSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  events: PropTypes.array.isRequired,
  onShowPathChange: PropTypes.func,
  timelineStatus: PropTypes.string,
};

TimelineStatusSummary.defaultProps = {
  onShowPathChange: () => {},
  timelineStatus: "",
};

// eslint-disable-next-line max-len
export default withStyles(vehicleHistoryStyles)(
  withTranslation("common")(TimelineStatusSummary),
);
